import { KeyButton } from "../../../keyButton/KeyButton";



interface VinylsEditorComponentProps {
    name: string;
    button: string;
    isActive: boolean;
    onClick: () => void;
}

export const VinylsEditorComponent = ({name, button, isActive, onClick}: VinylsEditorComponentProps) => {
    return (
        <div className={isActive ? "vinyls-editor-component" : "vinyls-editor-component inactive"} onClick={onClick}>
            <img src={`./icons/64px/${name}.svg`} alt={name} />
            <div 
                className="vinyls-editor-button-wrapper"
                style={{
                    transform: `translateY(-20%) translateX(-20%)`
                }}
            >
                <KeyButton text={button} />
            </div>
        </div>
    )
}